export default {"src":"/_next/static/media/map.colour.21f37558.svg","height":364,"width":363,"blurWidth":0,"blurHeight":0};